<!--
 * @Author: Gaho
 * @Date: 2023-12-14 13:34:24
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-16 15:03:53
-->
<template>
    <div class="flex bets">
        <div class="flex flex-col text-[#93acd3] w-full bets">
            <div class="flex justify-between w-full profit-col font-semibold">
                <div class="flex items-center justify-between gap-1">
                    <span class="bets-label">{{ t.profit }}:</span>
                    <div class="flex items-center gap-1 bets-value">
                        <CurrentCoin size="16px" />
                        <span :class="Number(betsList.profit) >= 0 ? 'win' : 'lose'">
                            {{ Math.abs(Number(winAmount(betsList.profit))) }}
                        </span>
                    </div>
                </div>
                <div class="flex items-center justify-between gap-1">
                    <span class="bets-label">{{ t.chatWagered }}:</span>
                    <div class="flex items-center gap-1 bets-value">
                        <CurrentCoin size="16px" />
                        <span>{{ winAmount(betsList.wagered) }}</span>
                    </div>
                </div>
                <div class="flex items-center justify-between gap-1">
                    <span class="bets-label">{{ t.chatWin }}:</span>
                    <span class="bets-value win">{{ betsList.win }}</span>
                </div>
                
                <div class="flex items-center justify-between gap-1">
                    <span class="bets-label">{{ t.chatLoses }}:</span>
                    <span class="bets-value">{{ betsList.lose }}</span>
                </div>
                <Button class="text-[#93acd3] !p-0" @click.native="emit('handleShowCharts')">
                    <IconSvgUse
                        use="icon-arrow-down-small"
                        class="w-6 h-6 duration-100"
                        :class="[isShowCharts ? 'rotate-180' : '']"
                    />
                </Button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
const t = useTranslation();
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils';
const props = defineProps({
    betsList: {
        type: Object,
        default: {
            wagered: '0.00',
            profit: '0.00',
            win: 0,
            lose: 0
        },
    },
    isShowCharts: {
        type: Boolean,
        default: false,
    }
})
const emit = defineEmits(['handleShowCharts']);
</script>
<style lang="scss" scoped>
.bets {
    @media(max-width: 1000px){
        margin-bottom: 8px;
    }
}
.bets-label {
    color: #93acd3;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    margin: 0;
}
.bets-value {
    font-size: 12px;
}
.profit-col {
    display: flex;
    justify-content: space-between;
}
.win {
    color: #1bb83d;
}
.lose {
    color: #f42e59;
}
</style>